const initialState = {
  pending: false,
  message: null,
};

const Media = (state = initialState, action) => {
  switch (action.type) {
    case 'MEDIA_UPLOAD_START':
      return {
        ...state,
        message: false,
        pending: true,
      };

    case 'MEDIA_UPLOAD_FAILURE':
      return {
        ...state,
        message: action.message || null,
        pending: false,
      };

    case 'MEDIA_UPLOAD_SUCCESS':
      return {
        ...state,
        pending: false,
      };

    default:
      return state;
  }
};

export default Media;
